// extracted by mini-css-extract-plugin
module.exports = {"imageMobiinn":"_136VfC5L","text":"_2MxAZ88Y","imgNone":"_2MYr4x06","imgBlock":"_1mske5pi","mb28":"_145x543_"};